import { render } from "./static-page-detail.vue?vue&type=template&id=1fe6b106"
import script from "./static-page-detail.vue?vue&type=script&lang=js"
export * from "./static-page-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__